module.exports = __webpack_public_path__ + "static/media/material-dark.f77610e2.jpg";